<template>
  <section class="block portal client portal password-change">
    <div class="portal__wrapper">
      <div class="portal__content">
        <div class="account__item account__item--edit account__item--gradient">
          <form class="account__content" @input="error = false">
            <h2 class="title--l">{{ getUiString(['reaffirm', 'title']) }}</h2>
            <div class="text--emphasis">{{ getUiString(['reaffirm', 'text']) }}</div>
            <div class="form__row">
              <base-checkbox
              id="akkoord_check"
              :label="checkLabel"
              :allowLabelHtml="true"
              v-model="akkoord"></base-checkbox>
            </div>
            <button type="submit" class="button button--prim" :disabled="!akkoord" @click.prevent="saveSettings">{{ getUiString(['reaffirm', 'sendbutton']) }}</button>
          </form>
        </div>
      </div>
    </div>
    <lennoc-spinner v-if="busy" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ReaffirmTerms',
  data () {
    return {
      akkoord: false,
      busy: false
    }
  },
  methods: {
    async saveSettings () {
      this.busy = true
      await this.$store.dispatch('acceptTerms')
      const redirect = this.getRedirect
      if (redirect) {
        this.$store.dispatch('setPostLoginRedirect', null)
        window.location.replace(redirect)
      }
      this.busy = false
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      getRedirect: 'getPostLoginRedirect'
    }),
    checkLink () {
      return this.getUiString(['reaffirm', 'documentLink'])
    },
    checkLabel () {
      return `${this.getUiString(['reaffirm', 'affirmtext'])} <a class="link link--login" href="${this.checkLink}">${this.getUiString(['reaffirm', 'linktext'])}</a>`
    }
  }
}
</script>
